import { useSearchParams } from "react-router-dom"
import CreditReportsTab from "@/components/CreditReportsTab"
import TabNavigation from "@/components/TabNavigation"

export default function ReportsPage() {
  const [searchParams] = useSearchParams()
  const prescreenRequestId = searchParams.get('prescreenRequestId') || undefined

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Financial Integration API
          </h1>
        </div>

        <div className="space-y-4">
          <TabNavigation />
          <div className="space-y-4">
            <CreditReportsTab prescreenRequestIdFilter={prescreenRequestId} />
          </div>
        </div>
      </div>
    </div>
  )
}

